import React, { useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import { Button, Modal, DatePicker, Form, Input, message } from 'antd'
import { updateImplementationOffer } from '../../services/implementation-offer'
import { updateOffer } from '../../store/application'
import { userSelector } from '../../store/session'

const OfferModal = ({ showModal, id, number, date, onClose }) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)
  const { user } = useSelector(userSelector)
  const initFields = useMemo(
    () => ({
      number,
      date: moment(date || new Date()),
    }),
    [id, number, date]
  )

  const updateOfferHandler = (fields) => {
    setIsLoading(true)
    updateImplementationOffer(id, {
      data: {
        number: fields.number,
        date: fields.date,
        user: user.id,
      },
    })
      .then(() => {
        message.success('Реквизиты сохранены успешно')
        if (onClose) {
          dispatch(updateOffer({ id, number: fields.number, date: fields.date }))
          onClose()
        }
      })
      .catch((e) => message.error('Ошибка сохранения реквизитов'))
      .finally(() => setIsLoading(false))
  }

  return (
    <Modal
      title="Реквизиты документа"
      visible={showModal}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose} disabled={isLoading}>
          Отмена
        </Button>,
        <Button key="agree" onClick={() => form.submit()} disabled={isLoading}>
          Сохранить
        </Button>,
      ]}
    >
      <Form form={form} onFinish={updateOfferHandler} name="offer" initialValues={initFields} layout="vertical">
        <Form.Item label="Номер" name="number">
          <Input />
        </Form.Item>
        <Form.Item label="Дата" name="date">
          <DatePicker />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default OfferModal
